import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {API_URL} from '../../apis/functions';
import axios from 'axios';

const initialState = {
  articles: [],
  status: 'idle',
  error: null,
  page: 1
};

// Thunk to fetch articles
export const fetchExtraArticles = createAsyncThunk(
  'articles/fetchExtraArticles',
  async ({page}) => {
    const response = await axios.get(`${API_URL}/articles/type/extracurricular?page=${page}&limit=10`);
    return response.data;
  }
);

const articlesExtraSlice = createSlice({
  name: 'articlesExtra',
  initialState,
  reducers: {
    incrementPage(state) {
      state.page += 1;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExtraArticles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchExtraArticles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.articles = [...state.articles, ...action.payload];
      })
      .addCase(fetchExtraArticles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export const { incrementExtraPage } = articlesExtraSlice.actions;

export default articlesExtraSlice.reducer;
